import { offeredDepartmentId } from "../config/practice";
import { workingLocation } from "./workingLocation";

// The chat's "send enrollment form" link (9928 only, features.websiteLeads):
// C-HIM's high-bp.com enrollment page, as before. A login working at CODE
// (Athena department 3; the header shows CODE) texts CODE's own care intake
// instead, which stamps department 3 on the intake row.
export const CHIM_ENROLLMENT_LINK = "https://high-bp.com/patient-enrollment/";
export const CODE_ENROLLMENT_LINK = "https://care.brainymed.com/onboard-code";

export function enrollmentLink(config) {
  const atCode = workingLocation(config) === "3" && offeredDepartmentId("3") === "3";
  return atCode ? CODE_ENROLLMENT_LINK : CHIM_ENROLLMENT_LINK;
}
